"use client";

import { useState } from "react";
import { Box, Dialog, Fab, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import { ContactForm } from "./ContactForm";
import { usePathname } from "next/navigation";

function ContactDialog({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <Box
        sx={{
          maxWidth: "400px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "grey.200",
            padding: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box>
            <Typography variant="body2">Contact Horsezone</Typography>
            <Typography variant="h6">How can we help?</Typography>
          </Box>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              backgroundColor: "white",
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box
          sx={{
            padding: 2,
          }}
        >
          <ContactForm />
        </Box>
      </Box>
    </Dialog>
  );
}

const ALLOWED_PATHS = ["/sell", "/auth", "/members"];

export function ContactButton() {
  const [isOpen, setIsOpen] = useState(false);
  const pathName = usePathname();
  if (!ALLOWED_PATHS.some((allowedPath) => pathName.startsWith(allowedPath))) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        right: 0,
        padding: 2,
        zIndex: 1500,
        overflow: "visible",
      }}
    >
      <Fab onClick={() => setIsOpen(!isOpen)} variant="extended">
        <ChatBubbleIcon />
        <Typography
          sx={(them) => ({
            marginLeft: 1,
            [them.breakpoints.down("sm")]: {
              display: "none",
            },
          })}
        >
          Contact / Feedback
        </Typography>
      </Fab>

      <ContactDialog isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </Box>
  );
}
